<template>
  <div :class="$style.applicationChooserQuickAccess">
    <div :class="$style.sidebarSpacer" />
    <div :class="$style.content">
      <div :class="$style.legend">
        <p>
          <strong :class="$style.legendHighlightText">Can’t find an application?</strong>
          Try one of these options:
        </p>
      </div>

      <div :class="$style.actions">
        <IconButton
          ariaLabel="Configure new Custom SAML App"
          :class="$style.actionsButton"
          :hasNoBackground="false"
          icon="application"
          :scale="1"
          text="Custom SAML App"
          type="secondary"
          @click="createNewSamlApplication"
        />
        <IconButton
          ariaLabel="Configure new Custom OIDC App"
          :class="$style.actionsButton"
          :hasNoBackground="false"
          icon="application"
          :scale="1"
          text="Custom OIDC App"
          type="secondary"
          @click="createNewOidcApplication"
        />
        <IconButton
          ariaLabel="Configure new Bookmark Configure and Identity Management"
          :class="$style.actionsButton"
          :hasNoBackground="false"
          icon="bookmark"
          :scale="1"
          text="URL Bookmark"
          type="secondary"
          @click="createNewBookmark"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { IconButton } from '@jumpcloud/ui-components';
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';

const { applicationTemplate } = ItemTypeConsts;
const applicationTemplateCollection = StoreModuleMap[applicationTemplate];

export default {
  name: 'ApplicationChooserQuickAccess',

  components: {
    IconButton,
  },

  computed: {
    ...mapGetters(applicationTemplateCollection, [
      'genericOidcTemplateId',
      'genericTemplateId',
      'genericBookmarkId',
    ]),
  },

  methods: {
    ...mapActions(applicationTemplateCollection, [
      'fetchGenericOidcTemplate',
      'fetchGenericTemplate',
      'fetchGenericBookmark',
    ]),

    async createNewBookmark() {
      await this.fetchGenericBookmark();
      this.$emit('templateSelect', this.genericBookmarkId);
    },

    async createNewOidcApplication() {
      await this.fetchGenericOidcTemplate();
      this.$emit('templateSelect', this.genericOidcTemplateId);
    },

    async createNewSamlApplication() {
      await this.fetchGenericTemplate();
      this.$emit('templateSelect', this.genericTemplateId);
    },
  },
};
</script>

<style module>
.applicationChooserQuickAccess {
  display: flex;
  margin-left: -10px;
  margin-right: -60px;
  width: calc(100% + 70px);
}

.sidebarSpacer {
  flex: 1;
  max-width: 30%;
  padding: 0 20px;
}

.content {
  align-items: center;
  display: flex;
  flex: 4;
  padding-left: 20px;
}

.legend {
  text-align: left;
}

.legendHighlightText {
  display: block;
}

.actions {
  display: flex;
  flex: 0 0 auto;
  padding: 0 76px 0 16px;
}

.actionsButton:not(:last-child) {
  margin-right: 8px;
}

.blue {
  background-color: var(--jcPrimary);
}
</style>
